import React from 'react'
import TableFixedPage from '../../TableFixedPage/TableFixedPage'
import AddResturantCategoryForm from '../../Forms/AddResturantCategoryForm/AddResturantCategoryForm'

const AddResturantCategoryContainer = () => {
  return (
    <div>
        <TableFixedPage title={"افزودن دسته بندی رستوران"} />
        <AddResturantCategoryForm/>
    </div>
  )
}

export default AddResturantCategoryContainer